import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/careers', label: 'Careers' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className={`navbar-solafy ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/" className="brand-link">
            <div className="brand-logo-container">
              <div className="brand-logo">
                <img
                  src="/images/global-solar-logo-new.png"
                  alt="Global Solar Energy Logo"
                  className="logo-image"
                />
              </div>
            </div>
          </Link>
        </div>

        <nav className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-nav">
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
          
          {/* Mobile Social Icons - Same as header */}
          <div className="header-social-icons mobile-menu-social">
            <a href="https://www.facebook.com/share/1Df8uUaCoV/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.linkedin.com/company/global-solar-energy-amreli/" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.instagram.com/globalsolarenergy.amreli?igsh=Zmt4cmI3b3BtbXk4" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-instagram"></i></a>
            <a href="https://wa.me/917202858358" target="_blank" rel="noopener noreferrer" className="header-social-icon whatsapp-icon"><i className="fab fa-whatsapp"></i></a>
          </div>
        </nav>

        <div className="navbar-actions">
          <div className="header-social-icons">
            <a href="https://www.facebook.com/share/1Df8uUaCoV/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.linkedin.com/company/global-solar-energy-amreli/" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://www.instagram.com/globalsolarenergy.amreli?igsh=Zmt4cmI3b3BtbXk4" target="_blank" rel="noopener noreferrer" className="header-social-icon"><i className="fab fa-instagram"></i></a>
            <a href="https://wa.me/917202858358" target="_blank" rel="noopener noreferrer" className="header-social-icon whatsapp-icon"><i className="fab fa-whatsapp"></i></a>
          </div>
        </div>

        <button
          className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-overlay ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}></div>
    </header>
  );
};

export default Navbar;